/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

/* NPM Imports Start */
import React, {
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import './side-navigation-menu.scss';
import { off, on } from 'devextreme/events';
import { useDispatch, useSelector } from 'react-redux';
import ScrollView from 'devextreme-react/scroll-view';
import PropTypes from 'prop-types';
/* NPM Imports End */

/* Project Imports Start */
import { navigation } from '../../app-navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import { sidebaraction } from '../../store/action/userAction';
import { sidenavatag, activesidebar, iconwhite } from '../../constant';
/* Project Imports End */

/* CCS & Image imports Start */
import ReportListIcon from './../../assets/images/ReportIcon.png';
import BatchPhotoImportIcon from './../../assets/images/BatchimportIcon.png';
import ChecklistEditorIcon from './../../assets/images/ChecklistIcon.png';
import ConfigurationIcon from './../../assets/images/ConfigureIcon.png';
import DataTableIcon from './../../assets/images/DatatabeIcon.png';
import IssueChartIcon from './../../assets/images/IssueChartIcon.png';
import IssueGalleryIcon from './../../assets/images/IssueGalleryIcon.png';
import IssuePunchListIcon from './../../assets/images/IssuePunchIcon.png';
import AIHubIcon from './../../assets/images/AIHubIcon.png';
import AIHubWhiteIcon from './../../assets/images/whiteIcon/AIHubWhiteIcon.png';
import SiteAndEquipmentIcon from './../../assets/images/SiteIcon.png';
import UserListIcon from './../../assets/images/UserIcon.png';
import ReportListWhiteIcon from './../../assets/images/whiteIcon/ReportWIcon.png';
import BatchPhotoImportWhiteIcon from './../../assets/images/whiteIcon/BatchimportWIcon.png';
import ChecklistEditorWhiteIcon from './../../assets/images/whiteIcon/ChecklistWIcon.png';
import ConfigurationWhiteIcon from './../../assets/images/whiteIcon/ConfigureWIcon.png';
import DataTableWhiteIcon from './../../assets/images/whiteIcon/DatatabeWIcon.png';
import IssueChartWhiteIcon from './../../assets/images/whiteIcon/IssueChartWIcon.png';
import IssueGalleryWhiteIcon from './../../assets/images/whiteIcon/IssueGalleryWIcon.png';
import IssuePunchListWhiteIcon from './../../assets/images/whiteIcon/IssuePunchWIcon.png';
import SiteAndEquipmentWhiteIcon from './../../assets/images/whiteIcon/SiteWIcon.png';
import UserListWhiteIcon from './../../assets/images/whiteIcon/UserWIcon.png';
import PartsListWIcon from './../../assets/images/whiteIcon/PartsListWIcon.png';
import PartsListIcon from './../../assets/images/PartsListIcon.png';

/* CCS & Image imports End */

const SideNavigationMenu = function(props) {
  const [sidebardata, setSidebardata] = useState('');
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(sidebaraction('menugroup'));
  }, []);
  const sidebarres = useSelector(state => state);
  const user = useSelector(state => state.configuration.user);
  const location = useLocation();
  useEffect(() => {
    if (
      user &&
      sidebarres.user.sidebardataresult &&
      document.querySelectorAll(sidenavatag)
    ) {
      [].forEach.call(document.querySelectorAll(sidenavatag), function(elem) {
        if (elem.getAttribute('href') === user) {
          elem.classList.add('activesidebar');
          document
            .querySelector(activesidebar)
            .querySelector('.icon')
            .classList.add('hide');
          document
            .querySelector(activesidebar)
            .querySelector(iconwhite)
            .classList.remove('hide');
        }
      });
    }
  }, [user, sidebarres.user.sidebardataresult]);
  useEffect(() => {
    if (sidebarres.user.sidebardataresult) {
      [].forEach.call(document.querySelectorAll(sidenavatag), function(elem) {
        if (elem.getAttribute('href') === location.pathname.replace('/', '#')) {
          const elems = document
            .querySelector('.beforesiderbar')
            .querySelectorAll(sidenavatag);
          const i = document.querySelectorAll('.beforesiderbar .icon');
          const whiteicon = document.querySelectorAll(
            '.beforesiderbar .iconwhite',
          );
          [].forEach.call(elems, function(el) {
            el.classList.remove('activesidebar');
          });
          [].forEach.call(i, function(el1) {
            el1.classList.remove('hide');
          });
          [].forEach.call(whiteicon, function(el1) {
            el1.classList.add('hide');
          });
          elem.classList.add('activesidebar');
          document
            .querySelector(activesidebar)
            .querySelector('.icon')
            .classList.add('hide');
          document
            .querySelector(activesidebar)
            .querySelector(iconwhite)
            .classList.remove('hide');
        }
      });
    }
  }, [sidebarres, location]);
  useEffect(() => {
    if (sidebarres.user.sidebardataresult) {
      const valData = sidebarres.user.sidebardataresult;
      const answers = valData.map(({ menuItems }, idx) => (
        <ul key={`${idx}`}>
          <li className="sidenavhead">
            <span className="sidenavleft">{valData[idx].menugroupname}</span>
          </li>
          {menuItems.map((val, index) => (
            <li key={`${index}`} className="lnkMenu" title={val.menuname}>
              <a
                className="sidenavatag"
                href={val.path}
                data-cy={`RSM-${val.path.substring(1)}-Link`}
                onClick={navtag}
                key={val.menuitemid}>
                {val.path === '#ReportList' ? (
                  <>
                    <img alt="icon" src={ReportListIcon} className="icon"></img>
                    <img
                      alt="icon"
                      src={ReportListWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#WorkPlanner' ? (
                  <>
                    <i className="dx-icon-cart icon work-planner-icon work-planner-icon-green"></i>
                    <i className="dx-icon-cart iconwhite hide work-planner-icon"></i>
                  </>
                ) : null}
                {val.path === '#IssuePunchList' ? (
                  <>
                    <img
                      alt="icon"
                      src={IssuePunchListIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={IssuePunchListWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#IssueGallery' ? (
                  <>
                    <img
                      alt="icon"
                      src={IssueGalleryIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={IssueGalleryWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#IssueChart' ? (
                  <>
                    <img alt="icon" src={IssueChartIcon} className="icon"></img>
                    <img
                      alt="icon"
                      src={IssueChartWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#DataTable' ? (
                  <>
                    <img alt="icon" src={DataTableIcon} className="icon"></img>
                    <img
                      alt="icon"
                      src={DataTableWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#CustomerList' ? (
                  <>
                    <img alt="icon" src={UserListIcon} className="icon"></img>
                    <img
                      alt="icon"
                      src={UserListWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#SuperAdmin' ? (
                  <>
                    <img alt="icon" src={UserListIcon} className="icon"></img>
                    <img
                      alt="icon"
                      src={UserListWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#ChecklistEditor' ? (
                  <>
                    <img
                      alt="icon"
                      src={ChecklistEditorIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={ChecklistEditorWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#siteequipment' ? (
                  <>
                    <img
                      alt="icon"
                      src={SiteAndEquipmentIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={SiteAndEquipmentWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#UserList' ? (
                  <>
                    <img alt="icon" src={UserListIcon} className="icon"></img>
                    <img
                      alt="icon"
                      src={UserListWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#Configuration' ? (
                  <>
                    <img
                      alt="icon"
                      src={ConfigurationIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={ConfigurationWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#FailureMode' ? (
                  <>
                    <img alt="icon" src={ConfigurationIcon} className="icon" />
                    <img
                      alt="icon"
                      src={ConfigurationWhiteIcon}
                      className="iconwhite hide"
                    />
                  </>
                ) : (
                  ''
                )}
                {val.path === '#PartsList' ? (
                  <>
                    <img alt="icon" src={PartsListIcon} className="icon" />
                    <img
                      alt="icon"
                      src={PartsListWIcon}
                      className="iconwhite hide"
                    />
                  </>
                ) : (
                  ''
                )}
                {val.path === '#BatchPhotoImport' ? (
                  <>
                    <img
                      alt="icon"
                      src={BatchPhotoImportIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={BatchPhotoImportWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#Features' ? (
                  <>
                    <img
                      alt="icon"
                      src={IssuePunchListIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={IssuePunchListWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#AIHubLink' ? (
                  <>
                    <img alt="icon" src={AIHubIcon} className="icon"></img>
                    <img
                      alt="icon"
                      src={AIHubWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                {val.path === '#SingleSignOnConfiguration' ? (
                  <>
                    <img
                      alt="icon"
                      src={ConfigurationIcon}
                      className="icon"></img>
                    <img
                      alt="icon"
                      src={ConfigurationWhiteIcon}
                      className="iconwhite hide"></img>
                  </>
                ) : (
                  ''
                )}
                <span className="text">{val.menuname}</span>
              </a>
            </li>
          ))}
        </ul>
      ));
      setSidebardata(answers);
    }
  }, [sidebarres]);
  const { children, openMenu, compactMode } = props;

  const { isLarge } = useScreenSize();
  useMemo(() => navigation.map(item => ({ ...item, expanded: isLarge })), []);

  const {
    navigationData: { currentPath },
  } = useNavigation();

  const treeViewRef = useRef();
  const wrapperRef = useRef();
  const getWrapperRef = useCallback(
    element => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        off(prevElement, 'dxclick');
      }

      wrapperRef.current = element;
      on(element, 'dxclick', e => {
        openMenu(e);
      });
    },
    [openMenu],
  );

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  const navtag = event => {
    const elems = document
      .querySelector('.beforesiderbar')
      .querySelectorAll(sidenavatag);
    const i = document.querySelectorAll('.beforesiderbar .icon');
    const whiteicon = document.querySelectorAll('.beforesiderbar .iconwhite');
    [].forEach.call(elems, function(el) {
      el.classList.remove('activesidebar');
    });
    [].forEach.call(i, function(el1) {
      el1.classList.remove('hide');
    });
    [].forEach.call(whiteicon, function(el1) {
      el1.classList.add('hide');
    });
    event.currentTarget.classList.toggle('activesidebar');
    document
      .querySelector(activesidebar)
      .querySelector('.icon')
      .classList.add('hide');
    document
      .querySelector(activesidebar)
      .querySelector(iconwhite)
      .classList.remove('hide');
  };
  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}>
      {children}
      <ScrollView>
        <div className="beforesiderbar">{sidebardata}</div>
      </ScrollView>
    </div>
  );
};

export default SideNavigationMenu;

/* Component Display Name */
SideNavigationMenu.displayName = 'SideNavigationMenu';

/* PropsTypes Validation Start*/
SideNavigationMenu.propTypes = {
  children: PropTypes.node,
  openMenu: PropTypes.func,
  compactMode: PropTypes.bool,
};
/* PropsTypes Validation End*/

/* DefaultProps */
SideNavigationMenu.defaultProps = {};
/* DefaultProps */
